var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"interval":4000,"type":"card","height":"200px"}},_vm._l((6),function(item){return _c('el-carousel-item',{key:item},[_c('h3',{staticClass:"medium"},[_vm._v(_vm._s(item))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/contactus/MessageUs.vue?vue&type=template&id=f152e122&
// module id = null
// module chunks = 